import { type DeepReadonly, inject, provide, type Ref } from 'vue';

export type ComboboxContext = {
  dataTestid?: DeepReadonly<Ref<string | undefined>>;
  id?: DeepReadonly<Ref<string | undefined>>;
};

export const COMBOBOX_CONTEXT_KEY = Symbol();

export const provideComboboxContext = (context: ComboboxContext) =>
  provide(COMBOBOX_CONTEXT_KEY, context);

export const injectComboboxContext = () =>
  inject<ComboboxContext | undefined>(COMBOBOX_CONTEXT_KEY, undefined);
